module.exports = __webpack_public_path__ + "static/img/img2-2.c32afbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/img2-2.png
// module id = wMn9
// module chunks = 10